import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback } from 'react';

import FilterPanel from '../../TableView/components/FilterPanel';
import DataTable from '../../DataTable/components/DataTable';
import PayoutDownloadModal from './PayoutDownloadModal';
import CombinedPayoutDownloadModal from './CombinedPayoutDownloadModal';
import EventPayoutDownloadModal from './EventPayoutDownloadModal';
import { ToastContainer } from 'react-toastify';

var _ = require('lodash');

import { v4 as uuidv4 } from 'uuid';
const axios = require('axios').default;
import $ from 'jquery';
require('datatables.net-bs4');

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const decodeHtml = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const PayoutManager = ({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableEl,
  dataTableElChanged,
  filters,
  filtersChanged,
  csvColumns,
  combinedCsvPath,
  recentPayouts,
  eventCsvPath,
  searchEventsPath
}) => {
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadCsvPath, setDownloadCsvPath] = useState("");
  const [combinedModalOpen, setCombinedModalOpen] = useState(false);
  const [eventModalOpen, setEventModalOpen] = useState(false);

  const reduceFilters = (filters) => {
    return filters.filter((filter) => {
      return filter.value.length > 0;
    }).reduce((params, filter) => {
      var newParam = {};
      newParam[filter.paramName] = filter.value;

      return Object.assign(params, newParam);
    }, {});
  }

  const reducedFilters = useMemo(() => {
    return (
      reduceFilters(filters)
    );
  }, [
    filters
  ]);

  const updateFilter = (filter, value) => {
    var updated = filters.map((item) => {
      if (item.paramName === filter.paramName) {
        var arrayValue = Array(value).flat();
        var newItem = Object.assign({}, item, {value: arrayValue});

        return newItem;
      }

      return item;
    })

    filtersChanged(updated);
  }

  const debouncedUpdateFilter = _.debounce((filter, value) => {
    updateFilter(filter, value);
  }, 200)

  const handleCreatedRow = useCallback((row, data, dataIndex) => {
    const btn = row.querySelector('.payout-download-btn');
    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const csvPath = btn.dataset.payoutCsvPath;
        setDownloadCsvPath(csvPath);
        setDownloadModalOpen(true);
      });
    }
  }, []);

  const showExportButtons = csvColumns && csvColumns.length > 0;

  return (
    <div>
      <ToastContainer icon={false} />
      <FilterPanel filters={filters}
                    clearFilterValues={
                      () => {
                        var updated = filters.map((item) => {
                          return Object.assign({}, item, {value: []})
                        })

                        filtersChanged(updated);
                      }
                    }
                    debouncedUpdateFilter={debouncedUpdateFilter}
                    updateFilter={updateFilter} />
      {showExportButtons && (
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-setlist-secondary mr-2"
            onClick={() => setEventModalOpen(true)}
          >
            <i className="fas fa-calendar-alt mr-1"></i>
            Opendate Event Export
          </button>
          <button
            className="btn btn-setlist-secondary"
            onClick={() => setCombinedModalOpen(true)}
          >
            <i className="fas fa-file-export mr-1"></i>
            Opendate Combined Export
          </button>
        </div>
      )}
      <DataTable title={dataTableTitle}
                  dataSource={dataTableDataSource}
                  columns={dataTableColumns}
                  colGroup={
                    dataTableColumns.length === 9 ?
                    <colgroup>
                      <col span={1} style={{"width": "10%"}} />
                      <col span={1} style={{"width": "8%"}} />
                      <col span={1} style={{"width": "10%"}} />
                      <col span={1} style={{"width": "13%"}} />
                      <col span={1} style={{"width": "15%"}} />
                      <col span={1} style={{"width": "19%"}} />
                      <col span={1} style={{"width": "10%"}} />
                      <col span={1} style={{"width": "10%"}} />
                      <col span={1} style={{"width": "5%"}} />
                    </colgroup> : null
                  }
                  onTableElementSet={
                    (el) => {
                      dataTableElChanged(el);
                    }
                  }
                  createdRow={handleCreatedRow}
                  reducedFilters={reducedFilters}
                  order={dataTableOrder} />
      <PayoutDownloadModal
        open={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
        csvPath={downloadCsvPath}
        csvColumns={csvColumns || []}
      />
      <CombinedPayoutDownloadModal
        open={combinedModalOpen}
        onClose={() => setCombinedModalOpen(false)}
        combinedCsvPath={combinedCsvPath || ""}
        csvColumns={csvColumns || []}
        recentPayouts={recentPayouts || []}
      />
      <EventPayoutDownloadModal
        open={eventModalOpen}
        onClose={() => setEventModalOpen(false)}
        eventCsvPath={eventCsvPath || ""}
        csvColumns={csvColumns || []}
        searchEventsPath={searchEventsPath || ""}
      />
    </div>
  )
};

PayoutManager.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  dataTableEl: PropTypes.object,
  dataTableElChanged: PropTypes.func.isRequired,
  filters: PropTypes.array,
  filtersChanged: PropTypes.func.isRequired,
  csvColumns: PropTypes.array,
  combinedCsvPath: PropTypes.string,
  recentPayouts: PropTypes.array,
  eventCsvPath: PropTypes.string,
  searchEventsPath: PropTypes.string
};

export default PayoutManager;
